import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const clockOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M7-7.75v3.5a.26.26 0 0 1-.078.188A.23.23 0 0 1 6.75-4h-2.5a.28.28 0 0 1-.187-.062A.28.28 0 0 1 4-4.25v-.5q0-.106.063-.172A.26.26 0 0 1 4.25-5H6v-2.75q0-.106.063-.172A.26.26 0 0 1 6.25-8h.5q.106 0 .172.078.076.066.078.172m2.672 4.89A4.17 4.17 0 0 0 10.25-5q-.002-1.154-.578-2.125a4.1 4.1 0 0 0-1.547-1.547A4.1 4.1 0 0 0 6-9.25a4.17 4.17 0 0 0-2.14.578 4.2 4.2 0 0 0-1.547 1.547A4.17 4.17 0 0 0 1.75-5q0 1.158.563 2.14a4.3 4.3 0 0 0 1.546 1.548A4.23 4.23 0 0 0 6-.75q1.154 0 2.125-.562A4.2 4.2 0 0 0 9.672-2.86m1.516-5.156Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.001 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};